import { memo } from 'react'
import cn from 'classnames'

import type { SafeAreaProps } from './types'

import styles from './SafeArea.module.scss'

/** Обёртка с env(safe-area-inset-*) по запрошенным сторонам. */
export const SafeArea = memo(function SafeArea(props: SafeAreaProps) {
  const { edges = ['top', 'bottom'], children } = props

  return (
    <div
      className={cn(
        styles.root,
        edges.map((edge) => styles[`edge_${edge}`]),
      )}
    >
      {children}
    </div>
  )
})
